<template>
    <main id="home-wrapper">
        <div>
            <breadcrumb :breadcrumb="[
                { title: 'Community', url: '/', status: false },
                { title: 'Update Phone Number', url: app_url + '/event', status: true },
            ]"></breadcrumb>
            <section id="headline-events" class="section withPad blackBg">
                <div class="container">
                    <div class="wrapper-popup">
                        <div class="card-popup">
                            <div class="card-body">
                                <form @submit.prevent="onSubmit">
                                    <h4>Input Motor & Nopol Motor yang dipakai ke HBD</h4>
                                    <div class="form-group row"
                                        :id="form.errors.has('category_motor') ? 'error-field' : false">
                                        <div class="col">
                                            <label class="label-form" for="type">Kategori Motor</label>
                                            <div class="custom_vselect custom_vselect-large">
                                                <v-select :options="motorCategories" label="title"
                                                    placeholder="Pilih Kategori Motor"
                                                    @input="changeMotorCategory($event, 'category_motor')"
                                                    v-model="category">
                                                </v-select>
                                            </div>
                                            <span class="help-block" v-if="form.errors.has('category_motor')"
                                                v-text="form.errors.get('category_motor')">
                                            </span>
                                        </div>
                                    </div>
                                    <div class="form-group row"
                                        :id="form.errors.has('motor_id') ? 'error-field' : false">
                                        <div class="col">
                                            <label class="label-form" for="type">Varian Motor</label>
                                            <div v-if="category !== 'lain-lain'"
                                                class="custom_vselect custom_vselect-large">
                                                <v-select :options="motorVariants" label="title"
                                                    placeholder="Pilih Varian Motor"
                                                    @input="changeVarianMotor($event, 'variant_motor')"
                                                    v-model="variant">
                                                </v-select>
                                            </div>
                                            <div v-else>
                                                <input type="text" v-model="otherVariant"
                                                    class="form-control form-register" id="variant_motor"
                                                    aria-describedby="variant_motor" placeholder="Varian Motor" />
                                            </div>
                                            <span class="help-block" v-if="form.errors.has('variant_motor')"
                                                v-text="form.errors.get('variant_motor')">
                                            </span>
                                        </div>
                                    </div>
                                    <div class="form-group row"
                                        :id="form.errors.has('police_number') ? 'error-field' : false">
                                        <div class="col">
                                            <label class="label-form" for="police_number">Input Nomor Polisi
                                                Motor</label>
                                            <input type="text" class="form-control form-register nopol"
                                                id="police_number" maxlength="9" @keypress="validatePoliceNum($event)"
                                                aria-describedby="police_number" placeholder="Input Nomor Polisi Motor"
                                                v-model="form.police_number" />
                                            <span class="help-block" v-if="form.errors.has('police_number')"
                                                v-text="form.errors.get('police_number')">
                                            </span>
                                        </div>
                                    </div>
                                    <div class="message-join" v-if="message">
                                        {{ message }}
                                    </div>
                                    <div class="button">
                                        <div v-if="loader" class="loading loading-double"></div>
                                        <button v-else type="submit" class="btn btn-red mr-auto">Selanjutnya</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </main>
</template>
<script>
import BreadCrumb from "../../widget/BreadCrumb";
import 'vue-select/dist/vue-select.css';
import vSelect from "vue-select";
import { encrypt, decrypt } from '../../../lib/crypto'
export default {
    components: {
        breadcrumb: BreadCrumb,
        "v-select": vSelect,
    },
    data() {
        return {
            message: '',
            cdn_url: cdn_url,
            loader: false,
            base_url: "",
            app_url: "",
            api_url: "",
            motorCategories: [],
            motorVariants: [],
            category: '',
            variant: '',
            event: {},
            otherVariant: '',
            form: new Form({
                _token: token,
                event_attend_id: '',
                event_id: '',
                category_motor: '',
                variant_motor: '',
                police_number: ''
            }),
        }
    },
    created() {
        this.getMotorCategory()
        const event = localStorage.getItem('event-hbd');
        if (event) {
            this.event = JSON.parse(event);
        }
        this.handleGetDataEventAttendLocalStorage();
    },
    mounted() {
        window.addEventListener('pageshow', function (event) {
            if (event.persisted) {
                // The page was loaded from the cache, so reload it mounted
                window.location.reload();
            }
        });
    },
    watch: {
        otherVariant(data) {
            if (data.length) {
                this.form.variant_motor = JSON.stringify({ id: 'lain-lain', name: data });
            } else {
                this.form.variant_motor = '';
            }
        }
    },
    methods: {
        validatePoliceNum(event) {
            if (event.code == 'Space' || this.form.police_number.length > 9) {
                event.preventDefault();
            }
        },
        trackerUpdateInformation(event) {
            let data = {
                'event': 'updateInformation',
                'eventDetail.category': 'Join Event Community',
                'eventDetail.action': 'Input Motor & Nopol Motor',
                'eventName': event.name, //Event  Name
                'id': event.id,//Event ID
                'eventType': event.type,//Event Type
                'startDate': event.start_date, //Event Start Date
                'endDate': event.end_date, //Event End Date
                'publishedDate': event.created_at,//Event Created Date
                'motorCategory': this.category,
                'motorVariant': this.variant,
                'province': event.province,//Event Province
            }
            // console.log(data);
            dataLayer.push(data);
        },
        async onSubmit() {
            this.loader = true;
            this.form.event_id = this.event.id;
            this.trackerUpdateInformation(this.event);
            if (this.event.type === 'hbd-nasional') {
                this.onSubmitJoinCheck();
            } else {
                this.onSubmitJoinRegional();
            }
        },
        async onSubmitJoinCheck() {
            await this.form
                .post(`${api_url}/member/event/join-hbd-check`)
                .then(async (response) => {
                    if (response.status) {
                        const encryptData = await this.handleEncrypt(JSON.stringify(response.data.event_attend));
                        localStorage.setItem('update-police-number', true);
                        localStorage.setItem('event-attend-hbd', encryptData);
                        sessionStorage.setItem('event-attend-hbd', encryptData);
                        window.location.href = `${this.event.detail_url_web}/payment`
                        this.loader = false;
                    }
                    if (response.status_code == 'HCID_NOT_GENERATED') {
                        this.redirectUserHcid(response)
                    }
                }).catch(error => {
                    this.loader = false;
                    console.log(error, 'error');
                })
        },
        async onSubmitJoinRegional() {
            await this.form.post(`${api_url}/member/event/join-hbd`)
                .then(async (response) => {
                    if (response.status) {
                        const encryptData = await this.handleEncrypt(JSON.stringify(response.data.event_attend));
                        localStorage.setItem('update-police-number', true);
                        localStorage.setItem('payment-event', false);
                        localStorage.setItem('event-attend-hbd', encryptData);
                        window.location.href = `${this.event.detail_url_web}/thank-you`
                        this.loader = false;
                    }
                    if (response.status_code == 'HCID_NOT_GENERATED') {
                        this.redirectUserHcid(response)
                    }
                }).catch((error) => {
                    console.log(error);
                    this.loader = false;
                });
        },
        redirectUserHcid(response) {
            this.message = response.message;
            this.loader = false;
            setTimeout(() => {
                window.location.href = '/community/hcid';
            }, 3500)
        },
        async handleEncrypt(input) {
            try {
                const encryptText = await encrypt(input, process.env.MIX_ENCODED_SECRET_KEY);
                return encryptText
            } catch (error) {
                console.log(error)
                return false;
            }
        },
        async handleDecrypt(input) {
            try {
                return await decrypt(input, process.env.MIX_ENCODED_SECRET_KEY);
            } catch (error) {
                return false;
            }
        },
        async handleGetDataEventAttendLocalStorage() {
            const eventAttendEncrypt = localStorage.getItem('event-attend-hbd');
            if (eventAttendEncrypt) {
                await this.handleDecrypt(eventAttendEncrypt).then((data) => {
                    const eventAttend = JSON.parse(data);
                    let variant = typeof eventAttend.variant_motor === 'object' ? { id: eventAttend.variant_motor?.id, title: eventAttend.variant_motor?.name } : eventAttend.variant_motor;
                    this.form.eventAttend_id = eventAttend.id;
                    this.form.event_id = eventAttend.event_id;
                    this.form.police_number = eventAttend.police_number;
                    this.category = eventAttend.category_motor.name;
                    this.changeMotorCategory(eventAttend.category_motor, 'category_motor');
                    this.changeVarianMotor(variant, 'variant_motor');

                    if (variant.id !== 'lain-lain') {
                        this.variant = variant.title;
                    } else {
                        this.otherVariant = variant.title;
                    }
                })
            }
        },
        handleBackButtonBrowser() {
            console.log('resss')
        },
        getMotors() {
            axios.get(api_url + '/static/motor')
                .then(response => {
                    this.motorVariants = this.mapOptions(response.data.data.bike_type);
                }).catch(error => {
                    console.log(error);
                });
        },
        getMotorCategory() {
            this.loadderforms = false;
            axios.get(api_url + '/static/motor-category')
                .then(response => {
                    this.motorCategories = response.data.data.category_motor;
                    let others = {
                        title: "Lain-lain",
                        name: "lain-lain",
                    };
                    this.motorCategories.push(others);
                }).catch(error => {
                    console.log(error);
                });
        },
        changeMotorCategory(event, label) {
            this.form.variant_motor = '';
            this.variant = '';

            if (event) {
                this.form[label] = JSON.stringify(event);
                this.category = event.name;
                if (event.name !== 'lain-lain') {
                    this.getVarianMotor(event);
                }
            } else {
                this.form[label] = '';
                this.category = '';
            }
        },
        getVarianMotor(category) {
            axios.get(api_url + '/static/motor?type=' + category.name)
                .then(response => {
                    this.motorVariants = this.mapOptions(response.data.data.motor);
                }).catch(error => {
                    console.log(error);
                });
        },
        changeVarianMotor(event) {
            if (event) {
                let motor = { id: event.title, name: event.title };

                this.variant = event.title,
                    this.form.variant_motor = JSON.stringify(motor);
            } else {
                this.form.variant_motor = '';
                this.variant = '';
            }
        },
        mapOptions(data) {
            var items = data.map((item) => {
                return { id: item._id, title: item.name };
            });
            var uniqes = [...new Set(items)];
            return uniqes;
        },
    },
}
</script>
<style scoped lang="scss">
.message-join {
    position: relative;
    margin: 13px 0;
    padding-bottom: 13px;
    text-align: center;
    color: #e61c33;
    font-weight: 500;
    font-size: 15px;
}

.nopol {
    text-transform: uppercase;

    &::placeholder {
        text-transform: capitalize;
    }
}

.custom_vselect-large .vs__dropdown-toggle {
    padding: 5px !important;
}

.wrapper-popup {
    position: relative;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    .card-popup {
        position: relative;
        background-color: #fff;
        border-radius: 10px;
        padding: 10px;
        width: 558px;

        .button-close {
            position: absolute;
            left: auto;
            right: 15px;
        }

        .card-body {
            color: rgba(40, 40, 40, 1);
            height: 100%;

            p {
                font-size: 15px;
                width: 400px;
                color: rgba(63, 63, 63, 1);
            }

            .warning-text {
                margin-top: 5px;
            }

            .btn {
                width: 100%;
                max-width: 100%;
                font-weight: 700;
                font-size: 14px;
                padding: 0;
                height: 42px;
                border-radius: 10px;
                display: flex;
                align-items: center;
                justify-content: center;

                &:hover {
                    background-color: #333 !important;
                    color: #fff;
                }
            }

            #police_number {
                border-radius: 10px;
            }

            .phonebox {
                margin-bottom: 7px;
            }

            .red-button {
                width: 100%;
                background-color: #E61B33;
                color: #fff;
                padding: 10px 20px;
                border-radius: 10px;
                font-weight: 700;
                font-size: 14px;
                display: inline-block;
                cursor: pointer;
            }
        }
    }
}
</style>
